<template>
  <path
    id="bar_chart_FILL0_wght400_GRAD0_opsz24"
    d="M175.091-779.879v-8.8h5.03v8.8Zm-7.546,0V-800h5.03v20.121Zm-7.546,0v-13.833h5.03v13.833Z"
    transform="translate(-160 800)" />
</template>
